import { CHAPTER1 } from './chapter1';

export const STORY = {
  chapter1: CHAPTER1
  // add other chapters as needed
};
